export const setMetaTag = (name: string, content: string) => {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute("content", content);
  } else {
    const meta = document.createElement("meta");
    meta.name = name;
    meta.content = content;
    document.head.appendChild(meta);
  }
};

export const setPropertyMetaTag = (property: string, content: string) => {
  let element = document.querySelector(`meta[property="${property}"]`);
  if (element) {
    element.setAttribute("content", content);
  } else {
    const meta = document.createElement("meta");
    meta.setAttribute("property", property);
    meta.content = content;
    document.head.appendChild(meta);
  }
};
